//////////////////
// Tweaker
// ------------
// Basic tweaker wrapper to make minor DOM modifcations
//////////////////
App.Tweaker = (function() {
  // Variables
  var selectors = {
    block: ".block",
    topOffset: ".o-image-position-offset-top, .o-header-image-offset-top",
    topAndBottomOffset: ".o-image-position-offset-top-bottom",
    verticalOffset: ".o-verticaloffset",
    sideOffset: ".o-image-position-offset-side",
    backToTop: ".back-to-top"
  };

  var classes = {
    PAD_BOT: "o-padding-bottom",
    PAD_TOP: "o-padding-top"
  };

  function setBackToTopControl() {
    var btn = $(selectors.backToTop);
    if (btn.length) {
      btn.on("click", function() {
        gsap.to(window, { duration: 1.5, scrollTo: btn.attr("href") });
        return false;
      });
    }
  }

  /*
	Manage top offset image with more space on the bottom of the preceding element
	*/
  function topOffset() {
    try {
      var blocks = $(selectors.topOffset).prev(selectors.block);
      blocks.addClass(classes.PAD_BOT);
    } catch (e) {
      console.log("Couldn't add " + selectors.topOffset, e);
    }
  }

  /*
	Manage top and bottom offset image with more space on the top and bottom of the preceding and following element
	*/
  function topAndBottomOffset() {
    try {
      var blocks = $(selectors.topAndBottomOffset);

      $.each(blocks, function(i, el) {
        var block = $(el);
        block.prev(selectors.block).addClass(classes.PAD_BOT);
        block.next(selectors.block).addClass(classes.PAD_TOP);
      });
    } catch (e) {
      console.log("Couldn't add " + selectors.topOffset, e);
    }
  }

  /*
	Manage side offset image to ensure block is full height due to absolute position image
	*/
  function sideOffset() {
    try {
      var blocks = $(selectors.sideOffset);
      $.each(blocks, function(i, el) {
        var block = $(el);
        var col = block.find(".column");
        var img = block.find(".image img");
        var imgH = img.height();

        if (col.height() < imgH) {
          col.height(imgH);
        }

        function horizontalBoxFix() {
          img.css("left", -img.offset().left);
        }
        // horizontalBoxFix();

        window.addEventListener("resize", function(e) {
          console.log(e);
          // horizontalBoxFix();
        });
      });
    } catch (e) {
      console.log("Couldn't add " + selectors.sideOffset, e);
    }
  }

  function flagSingleItemLists() {
    var singles = $("ul, ol");
    if (singles.length) {
      singles.each(function(index, element) {
        var list = $(element);
        if (list.children("li").length < 3) {
          list.addClass("no-cols");
        }
      });
    }
  }

  /*
	Add extra spacing on any .block element before a .block with .o-verticaloffset
	*/
  function verticalOffset() {
    try {
      vOffsetBlocks = $(selectors.verticalOffset);
      $(vOffsetBlocks).each(function(i, item) {
        // Get as Cash object
        var el = $(item);

        // Fix height issue due to using relative positioning/transforms
        var img = el.find("img");
        el.height(img.height());

        // Find previous siblings and append class
        var prev = el.prev();
        if (prev) {
          prev.addClass("o-pre-verticaloffset");
        }
      });
    } catch (e) {
      console.log("Couldn't add " + selectors.verticalOffset, e);
    }
  }

  App.register(function() {
    App.log("Registered: App.Tweaker");
    topOffset();
    topAndBottomOffset();
    sideOffset();
    setBackToTopControl();
    flagSingleItemLists();
    // verticalOffset();
  });
})();
